export const LIMITED_WORKSPACE_EMPLOYEE_LIMIT = 5;

export function employeesWithinLimit<T>(employees: T[], limit = LIMITED_WORKSPACE_EMPLOYEE_LIMIT) {
  return employees.slice(0, limit);
}

export function employeeLimitReached(
  employeeCount: number,
  limit = LIMITED_WORKSPACE_EMPLOYEE_LIMIT,
) {
  return employeeCount >= limit;
}
